import React from 'react';
import { Divider as AntDivider } from 'antd';

interface DividerProps {
  className?: string;
}

const Divider = function ({ className }: DividerProps) {
  return <AntDivider className={className} />;
};

export { Divider };
